<script>
	import { resource } from '$lib/utils';
	import ItemsWithFilter from '$lib/sections/ovbs/itemsWithFilter.svelte';
	import { blur, fade } from 'svelte/transition';
	import { page } from '$app/stores';
	import Icon from '@iconify/svelte';
	export let data = {};
	let ovbs_items;
	let ovbs_landing;
	$: if (data?.ovbs_items) {
		ovbs_items = data?.ovbs_items;
		ovbs_landing = data?.ovbs_landing;
	}
	$: selectedYear = $page.params.year;
	let years = [];
	let beginningYear = 2023;
	for (let i = beginningYear; i <= new Date().getFullYear(); i++) {
		years.push(i);
	}
</script>

{#if data?.ovbs_items.length > 0 && data?.ovbs_landing.length > 0}
	<div class="w-full bg-[#F6F6F6] relative" in:fade={{ duration: 1000 }}>
		{#if ovbs_landing}
			<img
				src={resource(ovbs_landing[0]?.field_poster?.field_media_image.uri.url)}
				class="w-full max-h-[calc(100svh-125px)] min-[1960px]:max-h-[900px] min-h-[400px] h-full object-cover ovbsBanner"
				alt="landing"
				in:fade={{ duration: 1000 }}
			/>
		{/if}
	</div>
	<div id="start" class="h-0 pt-10"></div>
	<ItemsWithFilter items={ovbs_items}>
		<svelte:fragment slot="year-list">
			<div class="relative lg:text-lg h-full mb-2 flex justify-between items-center">
				<div
					class="h-auto group flex gap-2 items-center bg-white text-[15px] sm:text-base w-[75px] sm:w-[90px] justify-between px-2 py-1 box-border cursor-pointer"
				>
					{selectedYear}
					<Icon icon="mdi:arrow-down-drop" width="25px" height="25px" style="color: #ffc000" />
					<ul
						class=" -z-[1] opacity-0 pointer-events-none group-hover:pointer-events-auto group-hover:z-10 group-hover:opacity-100 absolute top-[75%] left-0 bg-white w-[75px] sm:w-[90px] box-border pt-3 py-2 px-2 gap-2 flex flex-col duration-300 ease-in-out"
					>
						{#each years as year}
							<li
								class="text-[15px] sm:text-base text-black cursor-pointer hover:text-[#ffc000] duration-300 ease-in-out"
							>
								<a href="/ovbs/{year}">{year}</a>
							</li>
							<!-- content here -->
						{/each}
					</ul>
				</div>
			</div>
		</svelte:fragment>
	</ItemsWithFilter>
{:else}
	<div
		class="w-full h-[calc(100svh-130px)] min-h-[400px] flex items-center justify-center bg-[#F6F6F6] relative"
		transition:blur={{ amount: 10, duration: 300 }}
	>
		No Data Available
	</div>
{/if}

<style>
	@media (max-height: 800px) {
		:global(.ovbsBanner) {
			max-height: 800px !important;
		}
	}
</style>
